
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaymentSettingsCard',

  props: {
    icon: { type: String, default: 'mdi-bank' },
    expanded: { type: Boolean, default: false },
    inPlace: { type: Boolean, default: false },
  },

  data: () => ({
    localExpanded: false,
  }),

  computed: {
    expandable(): boolean {
      return !!this.$scopedSlots.content;
    },

    showBorder(): boolean {
      return !this.inPlace || this.localExpanded;
    },
  },

  async mounted() {
    this.onPropExpanded(this.expanded);
    await this.$nextTick();
  },

  methods: {
    action() {
      if (this.expandable) {
        this.localExpanded = !this.localExpanded;
        this.$emit('update:expanded', this.localExpanded);
      }
      this.$emit('click');
    },

    onPropExpanded(val: boolean) {
      this.localExpanded = val;
    }
  },

  watch: {
    expanded(val: boolean) {
      this.onPropExpanded(val);
    }
  }
});
